import type { KeyboardEvent as ReactKeyboardEvent } from 'react';

/**
 * Enter-to-advance for the CreateDrawer content area. Enter moves to the next
 * step (or fires the final-step CTA), reusing the Continue button's path so the
 * nav guard / validation still runs. Skipped for textareas, for Enter on a
 * focused button (it already activates that button), for contenteditable, and
 * when the final CTA is disabled (a create already in flight), and
 * when a child already handled Enter via preventDefault — e.g. the workshop-type
 * or region combobox uses Enter to pick an option.
 */
export function handleContentEnter(
  e: ReactKeyboardEvent,
  cur: number,
  lastIndex: number,
  onCta: (() => void) | undefined,
  go: (i: number) => void,
  canFire = true,
): void {
  if (e.key !== 'Enter' || e.defaultPrevented || e.shiftKey) return;
  const t = e.target as HTMLElement;
  if (t.tagName === 'TEXTAREA' || t.tagName === 'BUTTON' || t.isContentEditable) return;
  e.preventDefault();
  if (cur === lastIndex) {
    if (canFire) onCta?.();
  } else go(cur + 1);
}
